import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import Dashboard from "../components/dashboard/Dashboard";
import SearchHeader from "../components/SearchHeader";
import { useLoader } from "../context/LoaderContext";
import { IComplaint, ICooperative } from "../exports/interfaces";
import { fetchCooperative } from "../api/DashboardApi";
import { dynamicFailed } from "../hooks/useToast";
import { fetchComplaints } from "../api/ComplaintApi";
import { useUser } from "../context/UserContext";

const DashboardPage = () => {
  const { setLoading } = useLoader();
  const [cooperative, setCooperative] = useState<ICooperative[]>([]);
  const [complaint, setComplaint] = useState<IComplaint[]>([]);
  const { user } = useUser();
  useEffect(() => {
    if(!user) {
      return
    }
    Promise.all([fetchCooperative(), fetchComplaints()])
      .then(([cooperativeData, complaintData]) => {
        setCooperative(cooperativeData);
        setComplaint(complaintData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading, user]);
  return (
    <>
      <PageLayout>
        <SearchHeader />
        <div className="inner-main-content">
          <Dashboard cooperative={cooperative} complaint={complaint} setCooperative={setCooperative}/>
        </div>
      </PageLayout>
    </>
  );
};

export default DashboardPage;
